module.exports = __webpack_public_path__ + "img/xmo.164decb6.svg";